import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { AnimationService, AnimationBuilder } from 'css-animator';

@Component({
  selector: 'modal-help-swipe',
  templateUrl: 'modal-help-swipe.html'
})
export class ModalHelpSwipeComponent {

  @Input() configColor: any;
  @Input() localstorageName: string = 'viewOnBoarding';
  @ViewChild('modalContainer') modalContainer: ElementRef;

  public showModal: boolean = false;
  private animatorModal: AnimationBuilder;

  constructor(
    public animationService: AnimationService
  ) { }

  ngOnInit(): void {
    let valueView = window.localStorage.getItem(this.localstorageName);
    if (valueView !== "true") {
      this.showModal = true;
      setTimeout(() => {
        this.animatorModal = this.animationService.builder();
        // this.animatorModal.setType('fadeIn').show(this.modalContainer.nativeElement);
      }, 800);
    }
  }

  closeModal() {
    this.animatorModal.setType('fadeOut').hide(this.modalContainer.nativeElement);
    window.localStorage.setItem(this.localstorageName, "true");
    setTimeout(() => {
      this.showModal = false;
    }, 600);
  }
}



// WEBPACK FOOTER //
// ./src/components/modal-help-swipe/modal-help-swipe.ts